module.exports = __webpack_public_path__ + "img/image12.5af38a3c.jpg";